import { RadioButtonOption } from "../../../common/enums";

export const BEEF_GAS_CHECKLIST_VERSION_2026_02 = 1;

export type BeefGasChecklist = {
    checklistVersion: number | undefined;
    needsFreshAirDevice: RadioButtonOption;
    isFreshAirMaskForEveryone: RadioButtonOption;
    isPortableGasMeasurementAlarmAvailableForEveryone: RadioButtonOption;
    isContinousGasMeasurementsInPlace: RadioButtonOption;
    isContinuousVentilationInPlace: RadioButtonOption;
    isFreshAirMaskNeededDuringWork: RadioButtonOption;
    isContinuousVentilationNeeded: RadioButtonOption;
    isOxygenLevelGasMeterAvailable: RadioButtonOption;
    isContinousGasMeasurementsInPlaceForEntirityOfWork: RadioButtonOption;
    isWindDirectionConsideredDuringWork: RadioButtonOption;
};

